import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private httpService: HttpService) { }
  fetchCompany() {
    return this.httpService.get('api/CompanyProfile');
  }
  fetchCompnayAccounts(payload: any) {
    return this.httpService.getList(
      'api/CompanyProfile/GetCompnayAccounts',
      payload
    );
  }
  updateCompany(payload: any) {
    return this.httpService.post('api/CompanyProfile', payload);
  }
  addUpdateGST(payload: any) {
    return this.httpService.post('api/CompanyProfile/AddUpdateGST', payload);
  }
  addGSTDetails(payload: any) {
    return this.httpService.post(
      'api/CompanyProfile/AddUpdateStateWiseGST',
      payload
    );
  }
  getAddedGST(accountId: string) {
    return this.httpService.get(
      'api/CompanyProfile/GetCompanyGST/' + accountId
    );
  }
  deleteGST(Id: string) {
    return this.httpService.delete('api/CompanyProfile/DeleteCompanyGST/' + Id);
  }
  deleteCompany(Id: string) {
    return this.httpService.delete(
      'api/CompanyProfile/DeleteCompnayAccounts/' + Id
    );
  }
  downloadCompanyAccountLogo(id: string) {
    return this.httpService.downloadFile(
      `api/CompanyProfile/${id}/downloadCompanyAccountLogo`
    );
  }
}
